import React from 'react'
import Slider from "react-slick";
import Link from 'gatsby-link'
import Navigation from '../Navigation'
import styled from 'styled-components'
import {injectGlobal} from 'styled-components'
import Grid from 'styled-components-grid'
import {GridContainer, Image, FullImage, Box, BlockedLink} from '../Styles'
import {Margin, mb, mt, py} from 'styled-components-spacing'
// content
import logoAiles from './logo-ailes-hautes-fine.png'
import pictoMeteo from './meteo-menu.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

injectGlobal`
  .slick-next {
    right: 2rem !important;
    z-index: 3;
  }
  .slick-prev {
    z-index: 3;
    left: 2rem !important;
  }
`
const sliderOpts = {
  autoplay: true,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 5000,
  fade: true,
  arrows: false,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1
}

const HeaderImage = styled.div`
  width: 100%;
  padding-bottom: 14vw;
  position: relative;
  background: ${props => props.bgImage ? `url(${props.bgImage})` : null} center center;
  background-size: cover;
`;

const LogoContainer = styled.div`
  position: relative;
  margin-bottom: 0;
  ${mt(2)};
  ${py(0)};
`;

const Close = styled.span`
  transform: rotate(45deg);
  display: inline-block;
  font-weight: bold;
  font-size: 1.2em;
  line-height: 1em;
`;

const MenuBar = styled.div`
  ${py(2)}
  background: white;
  position: fixed;
  top: 0;
  z-index: 50;
  width: 100%;
`;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      showMeteo: false
    };
  }
  render() {
    var tipLinks = {
      primary: {
        link: 'Conseil météo'
      },
      items: this.props.meteoLinks.tip_links
    }
    var usefulLinks = {
      primary: {
        link: 'Liens utiles'
      },
      items: this.props.meteoLinks.useful_links
    }
    var webcams = {
      primary: {
        link: 'Webcams'
      },
      items: this.props.meteoLinks.webcams
    }
    const meteoLinks = [tipLinks, usefulLinks, webcams];
    return (
      <div>
        <MenuBar>
          <GridContainer>
            <Grid halign="justify">
              <Grid.Unit size={1/3}>
                <Margin left={4}>
                  <button  
                    onClick={() => this.setState(prevState=>({showMenu:false, showMeteo:!prevState.showMeteo}))}
                    onBlur={() => setTimeout( () => this.setState(prevState=>({showMeteo:false})), 200 )}>
                    <Image width="1.5rem" m={0} pr={2} src={pictoMeteo} alt="picto météo" />
                    Météo
                  </button>
                </Margin>
              </Grid.Unit>
              <Grid.Unit size={1/3}>
                <Margin right={4} style={{textAlign:'right'}}>
                  <button 
                    onClick={() => this.setState(prevState=>({showMenu:!prevState.showMenu, showMeteo:false}))}
                    onBlur={() => setTimeout( () => this.setState(prevState=>({showMenu:false})), 200 )}>
                    {!this.state.showMenu ? (
                      <span>&#9776;</span>
                    ) : (
                      <Close>+</Close>
                    )} Menu
                  </button>
                </Margin>
              </Grid.Unit>
            </Grid>
          </GridContainer>
          <Box position="absolute">
            <LogoContainer>
              <BlockedLink
                to="/">
                <FullImage src={logoAiles} alt="Logo Airfly, école de parapenthe à Mauborget" />
              </BlockedLink>
            </LogoContainer>
          </Box>
        </MenuBar>
        <Box position="relative" style={{marginTop:'45px',marginBottom: '20px'}}>
          <Box position="fixed" style={{zIndex:10,width:'100%'}}>
            {this.state.showMenu &&
              <Navigation links={this.props.navigationLinks} injectContact={true} pagesUrl={this.props.pagesUrl}/>
            }
            {this.state.showMeteo && 
              <Navigation links={meteoLinks} pagesUrl={this.props.pagesUrl}/>
            }
          </Box>
          {this.props.bannerImages.length &&
            <Slider {...sliderOpts}>
              {this.props.bannerImages.map((bannerImage, id) => {
                return (
                  <FullImage 
                    key={`image-slider-${id}`} 
                    src={bannerImage.slideshow_image.url} 
                    alt={bannerImage.slideshow_image.alt || "image ambiance parapenthe"}
                    srcSet={[
                      bannerImage.slideshow_image.xl ? `${bannerImage.slideshow_image.xl.url} 1600w` : null,
                      bannerImage.slideshow_image.md ? `${bannerImage.slideshow_image.md.url} 1024w` : null,
                      bannerImage.slideshow_image.sm ? `${bannerImage.slideshow_image.sm.url} 640w` : null,
                    ]}
                    sizes="100vw"
                   />
                )
              })}
            </Slider>
          }
        </Box>
      </div>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.js